import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class TableMixin extends Vue {
  $refs!: {
    table: Vue & {
      refresh: () => void;
    };
  };

  modal = {
    open: false,
    id: '',
  };

  openModal(id = '') {
    this.modal.id = id;
    this.modal.open = true;
  }

  onUpdateData() {
    this.modal.open = false;
    this.$refs.table.refresh();
  }
}
